export Header from './Header'
export Footer from './Footer'
export Menu from './Menu'
export Contact from './Contact'
export Splash from './Splash'
export Carousel from './Carousel'
export InstagramFeed from './InstagramFeed'
export SearchInput from './SearchInput'
export PostMeta from './PostMeta'
export SignupForm from './SignupForm'
export InputText from './InputText'
export InputEmail from './InputEmail'
export Submit from './Submit'
export Competition from './Competition'
export MetaTags from './MetaTags'


// WEBPACK FOOTER //
// ./src/components/index.js